export const EXTERNAL_LINK = {
  quiz: 'https://communityofguardians.involve.me/whats-my-sdg-number',
  donate:
    'https://www.zeffy.com/donation-form/donate-to-make-a-difference-7733',
  un: 'https://sdgs.un.org/',
  un_goals: 'https://sdgs.un.org/goals/goal',
  youtubeAbout: 'https://www.youtube.com/embed/9jEL3z4pOTg?si=uT97U37dnsotx1U5',
  cogFacebook: 'https://www.facebook.com/profile.php?id=61559647418221',
  cogInstagram: 'https://www.instagram.com/cogs.guardian',
  cogYoutube: 'https://www.youtube.com/@CommunityofGuardians',
  cogLinkein: 'https://www.linkedin.com/company/community-of-guardians',
}
